import { signOut } from "firebase/auth";
import FirebaseConfiguration from "../config/firebase";

export default async function () {
  const auth = FirebaseConfiguration.auth;
  await signOut(auth);
}
